/** Слово под число: `plural(3, "чат ждёт", "чата ждут", "чатов ждут")` → «чата ждут». */
export function plural(n: number, one: string, few: string, many: string): string {
  const d = Math.abs(n) % 100;
  const u = d % 10;
  if (u === 1 && d !== 11) return one;
  return u >= 2 && u <= 4 && (d < 12 || d > 14) ? few : many;
}
